import { useMsal } from '@azure/msal-react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch, type PersonDetail, type PoolPerson } from './client';

export function usePoolSearch(q: string) {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['pool', q],
    queryFn: () => apiFetch<PoolPerson[]>(instance, `/api/candidates?q=${encodeURIComponent(q)}`),
  });
}

export function usePerson(id: string | undefined) {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['person', id],
    queryFn: () => apiFetch<PersonDetail>(instance, `/api/candidates/${id}`),
    enabled: Boolean(id),
  });
}

export function useUpdatePerson(id: string) {
  const { instance } = useMsal();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: { fullName?: string; phone?: string | null; compensation?: string | null }) =>
      apiFetch(instance, `/api/candidates/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['person', id] });
      qc.invalidateQueries({ queryKey: ['pool'] });
    },
  });
}
